import {
  AllFulfillmentTypesType,
  OrderGetResponseType,
} from "@sellar-io/api-v2/types";

export const getIsSwitchingBuyerOrderFromSellarDistribution = ({
  order,
  fulfillmentType,
}: {
  order: Pick<OrderGetResponseType, "fulfillmentType" | "initiator">;
  fulfillmentType: AllFulfillmentTypesType;
}): boolean =>
  order.fulfillmentType === "sellarDistribution" &&
  fulfillmentType !== "sellarDistribution" &&
  order.initiator === "retailer";
